import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {Grid} from '@material-ui/core';
import Loader from 'ui/atoms/Loader';

import {useAuthFetch} from 'context/fetch-context';

function Splash() {
  const {account} = useAuthFetch();
  const history = useHistory();

  useEffect(() => {
    if (account) {
      history.goBack();
    }
  }, [account, history]);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{minHeight: '90vh'}}
    >
      <Loader />
    </Grid>
  );
}

export default Splash;
